/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { t } from 'es6/services/localization';
import ProgressBar from 'es6/components/common/progress-bar';

import {
  ITEM_PROGRESS_LABEL_COLOR,
  ITEM_PROGRESS_PERCENTAGE_COLOR,
} from 'es6/core/styles/colors';

export default function Progress({ progress }) {
  return (
    <div className={css(styles.progress)}>
      <p>
        <span className={css(styles.label)}>{t('items-page.progress')}</span>
        {' '}
        <span className={css(styles.percentage)}>{progress}%</span>
      </p>
      <ProgressBar progress={progress} />
    </div>
  );
}

const styles = StyleSheet.create({
  progress: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  label: {
    color: ITEM_PROGRESS_LABEL_COLOR,
  },
  percentage: {
    color: ITEM_PROGRESS_PERCENTAGE_COLOR,
  },
});
